export default [
	{
		path: "/admin",
		component: () => import("@/views/admin/UserList"),
		meta: { layout: "Admin", menu: "", title: "Users List" }
    },
	{
		path: "/basic",
		component: () => import("@/views/admin/Basic"),
		meta: { layout: "Admin", menu: "", title: "Admin. Basic Info" }
    },
	{
		path: "/detail",
		component: () => import("@/views/admin/Detail"),
		meta: { layout: "Admin", menu: "", title: "Admin. Personal info" }
    },
	{
		path: "/edit",
		component: () => import("@/views/admin/Edit"),
		meta: { layout: "Admin", menu: "", title: "Admin. Edit personal info" }
	},
	{
		path: "/delete",
		component: () => import("@/views/admin/Delete"),
		meta: { layout: "Admin", menu: "", title: "Admin. Delete Account" }
	},
	{
		path: "/resetPwd",
		component: () => import("@/views/admin/ResetPwd"),
		meta: { layout: "Admin", menu: "", title: "Admin. Reset Password" }
	},
	{
		path: "/editAccount",
		component: () => import("@/views/admin/EditAccount"),
		meta: { layout: "Admin", menu: "", title: "Admin. Account" }
	},
];